<template>
  <b-card no-body>
    <div class="card-smallHeader card-header-action" v-b-toggle.collapse-aide-gestion>
      <span><b>Aide Gestion</b></span>
      <b-badge v-if="nbConsigne > 0" variant="danger" pill class="ml-2">{{ nbConsigne }}</b-badge>
      <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
        <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
      </div>
    </div>
    <b-collapse id="collapse-aide-gestion" class="m-3" v-model="showAideGestion" :class="showAideGestion ? null : 'collapsed'">
      <b-row>
        <b-col v-for="(consigne , key) in blocConsignes" :key="`consigne-produit-${consigne.id}`" style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
          <b-row>
            <b-col sm="12" style="position: relative; top: -12px;">
              <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Consigne produit {{ blocConsignes.length > 1 ? key + 1 : '' }} : </b></span>
            </b-col>
          </b-row>
          <b-form-group
            label-for="consignes_famille_produit"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Famille produit</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" id="consignes_famille_produit" type="text">{{ consignesFamilleproduit }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigne.commentaire"
            label-for="consigne_traitement_famille"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Consigne</b><br>
            </template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="consigne_commentaire"
              type="text"
              rows="6"
              max-rows="6">{{ consigne.commentaire }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigne.date_fin"
            label-for="dateFinPrevue"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Date de fin prévue</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="dateFinPrevue">{{ formatDate(consigne.date_fin) }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigne.consigne_attachments.length > 0"
            label-for="piecesJointes"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Pièces jointes</b></template>
            <div v-if="consigne.consigne_attachments">
              <li v-for="pj in consigne.consigne_attachments" :key="pj.id" style="list-style:none">
                <a :id="`pj_${pj.id}`" href="#" @click.prevent="download(pj.id, pj.nom_fichier)" style="font-size:12px;color:#831491"><i class="fa fa-tag"></i> {{ pj.nom_fichier }}
                ({{ formatBytes(pj.taille) }})</a>
              </li>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="codeBlocage">
        <!-- <b-col :class="calculClassBlocGestion('codeBlocage')" style="border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;"> -->
        <b-col style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
          <b-row>
            <b-col sm="12" style="position: relative; top: -12px;">
              <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Consigne blocage : </b></span>
            </b-col>
          </b-row>
          <b-form-group
            label-for="code_blocage"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Code blocage</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" id="code_blocage" type="text" disabled>{{ codeBlocage }}</div>
          </b-form-group>
          <b-form-group
            label-for="libelle_blocage"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Libellé</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" id="libelle_blocage" type="text">{{ libelleBlocage }}</div>
          </b-form-group>
          <b-form-group
            label-for="consigne_traitement_blocage"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Consigne traitement</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="consigne_traitement_blocage"
              type="text"
              rows="4"
              max-rows="6">{{ consigneTraitementBlocage }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col v-for="consigneSiren in consignesSiren" :key="`consigne-siren-${consigneSiren.id}`" :class="calculClassBlocGestion('siren')" style="border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;"> -->
        <b-col v-for="(consigneSiren, key) in consignesSiren" :key="`consigne-siren-${consigneSiren.id}`" style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
          <b-row>
            <b-col sm="12" style="position: relative; top: -12px;">
              <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Consigne SIREN {{consignesSiren.length > 1 ? key + 1 : ''}} : </b></span>
            </b-col>
          </b-row>
          <b-form-group
            label-for="consignes_siren"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Segment</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" type="text" :id="`tooltip-siren-${consigneSiren.id}`">
              {{ consigneSiren.siren.length > 29 ? consigneSiren.siren.substring(0,29) + '...' : consigneSiren.siren }}
            </div>
            <b-tooltip v-if="consigneSiren.siren.length > 29" :target="`tooltip-siren-${consigneSiren.id}`" triggers="hover" placement="top">{{ consigneSiren.siren }}</b-tooltip>
          </b-form-group>
          <b-form-group
            label-for="consigne_siren"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Consigne</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="consigne_siren"
              type="text"
              rows="6"
              max-rows="6">{{ consigneSiren.commentaire }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigneSiren.date_fin"
              label-for="dateSirenFinPrevue"
              :label-cols="3"
              :horizontal="true">
            <template slot="label"><b>Date de fin prévue</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="dateSirenFinPrevue">{{ formatDate(consigneSiren.date_fin) }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigneSiren.consigne_attachments.length > 0"
              label-for="piecesJointes"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Pièces jointes</b></template>
              <div v-if="consigneSiren.consigne_attachments">
                <li v-for="pj in consigneSiren.consigne_attachments" :key="pj.id" style="list-style:none">
                  <a :id="`pj_${pj.id}`" href="#" @click.prevent="download(pj.id, pj.nom_fichier)" style="font-size:12px;color:#831491"><i class="fa fa-tag"></i> {{ pj.nom_fichier }}
                  ({{ formatBytes(pj.taille) }})</a>
                </li>
              </div>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col v-for="consigneSegment in consignesSegment" :key="`consigne-segment-${consigneSegment.id}`" :class="calculClassBlocGestion('segment')" style="border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;"> -->
        <b-col v-for="consigneSegment in consignesSegment" :key="`consigne-segment-${consigneSegment.id}`" style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
          <b-row>
            <b-col sm="12" style="position: relative; top: -12px;">
              <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Consigne segment {{consignesSegment.length > 1 ? key + 1 : ''}} : </b></span>
            </b-col>
          </b-row>
          <b-form-group
            label-for="consignes_segment"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Segment</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" id="consignes_segment" type="text">{{ consigneSegment.segment.libelle }}</div>
          </b-form-group>
          <b-form-group
            label-for="consigne_segment"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Consigne</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="consigne_segment"
              type="text"
              rows="6"
              max-rows="6">{{ consigneSegment.commentaire }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigneSegment.date_fin"
              label-for="dateSegmentFinPrevue"
              :label-cols="3"
              :horizontal="true">
            <template slot="label"><b>Date de fin prévue</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="dateSegmentFinPrevue">{{ formatDate(consigneSegment.date_fin) }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="(consigneNir, key) in consignesNir" :key="`consigne-nir-${consigneNir.id}`" style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
          <b-row>
            <b-col sm="12" style="position: relative; top: -12px;">
              <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Consigne NIR {{consignesNir.length > 1 ? key + 1 : ''}} : </b></span>
            </b-col>
          </b-row>
          <b-form-group
            label-for="consignes_nir"
            :label-cols="3"
            :horizontal="true">
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control" type="text" :id="`tooltip-nir-${consigneNir.id}`">
              {{ consigneNir.nir.length > 29 ? consigneNir.nir.substring(0,29) + '...' : consigneNir.nir }}
            </div>
            <b-tooltip v-if="consigneNir.nir.length > 29" :target="`tooltip-siren-${consigneNir.id}`" triggers="hover" placement="top">{{ consigneNir.nir }}</b-tooltip>
          </b-form-group>
          <b-form-group
            label-for="consigne_nir"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Consigne</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="consigne_nir"
              type="text"
              rows="6"
              max-rows="6">{{ consigneNir.commentaire }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigneNir.date_fin"
              label-for="dateNirFinPrevue"
              :label-cols="3"
              :horizontal="true">
            <template slot="label"><b>Date de fin prévue</b></template>
            <div style="background-color:#e4e7ea;opacity:1;height:auto"
              class="form-control"
              id="dateNirFinPrevue">{{ formatDate(consigneNir.date_fin) }}
            </div>
          </b-form-group>
          <b-form-group v-if="consigneNir.consigne_attachments.length > 0"
              label-for="piecesJointes"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Pièces jointes</b></template>
              <div v-if="consigneNir.consigne_attachments">
                <li v-for="pj in consigneNir.consigne_attachments" :key="pj.id" style="list-style:none">
                  <a :id="`pj_${pj.id}`" href="#" @click.prevent="download(pj.id, pj.nom_fichier)" style="font-size:12px;color:#831491"><i class="fa fa-tag"></i> {{ pj.nom_fichier }}
                  ({{ formatBytes(pj.taille) }})</a>
                </li>
              </div>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row style="margin-top:12px">
        <b-col><a href="#" @click.prevent="accessBibliotheque()">Accéder Espace Bibliothèque</a></b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
  import { isEmpty } from '@/utils/fileHelper';
  import {downloadFile, guardedFile} from "@/utils/fileHelper"

  export default {
    name: "AideGestion",
    data() {
      return {
        consignesFamilleproduit: '',
        codeBlocage: '',
        libelleBlocage: '',
        consigneTraitementFamille: '',
        //consigneTraitementBlocage: '',
        consignesSegment: [],
        consignesSiren: [],
        consignesNir: [],
        consignesBlocage: [],
        dateFinPrevue: '',
        piecesJointes: null,
        blocConsignes: [],
        nbConsigne: 0
        // showAideGestion2: false,
      }
    },
    props: [
      'dossier',
      'traitements'
    ],
    watch: {
      // consigneTraitementFamille() {
      //   this.showAideGestion = !this.$parent.$parent.$parent.isQualification && (!isEmpty(this.consigneTraitementFamille) || !isEmpty(this.dossier.code_blocage));
      // }
    },
    computed: {
      codeBlocageEmpty() {
        return isEmpty(this.dossier.code_blocage);
      },
      showAideGestion: {
        get(){
            return !this.$parent.$parent.$parent.isQualification && (!isEmpty(this.consigneTraitementFamille) || !isEmpty(this.dossier.code_blocage) || this.consignesSiren.length > 0 || this.consignesNir.length > 0 || this.consignesSegment.length > 0);
           },
        set() {
          return !this.$parent.$parent.$parent.isQualification && (!isEmpty(this.consigneTraitementFamille) || !isEmpty(this.dossier.code_blocage) || this.consignesNir.length > 0 || this.consignesSiren.length > 0 || this.consignesSegment.length > 0);

        }
      },
    },
    mounted() {
      this.setForm();
      if(!isEmpty(this.dossier.famille_produit_id)) {
        // this.getConsigneFamilleProduit(this.dossier.famille_produit_id);
        this.getConsigneGarantie(this.dossier.type.groupe, this.dossier.famille_produit_id);
      }
      this.getConsignes();
    },
    methods: {
      setForm() {
        this.consignesFamilleproduit = this.dossier.famille_produit ? this.dossier.famille_produit.libelle : '';
        this.codeBlocage = this.dossier.code_blocage;
        if (!isEmpty(this.dossier.code_blocage)) {
          this.nbConsigne++;
        }
        this.libelleBlocage = this.dossier.libelle_blocage;
        this.consigneTraitementBlocage = this.dossier.consignes_blocage && this.dossier.consignes_blocage.aide;
        this.consigneTraitementFamille = '';
      },
      isDisabled(field) {
        return true;
        // return !(field === 'consigneTraitementBlocage' && this.isTreatment('ij_validation_dossier_prestation'));
      },
      // getConsigneFamilleProduit(famille_produit_id) {
      //   this.$axios
      //     .get('/espaceGestion/consignes-famille-produits/' + famille_produit_id)
      //     .then(response => {
      //       this.consigneTraitementFamille = response.data.consigneProduit && response.data.consigneProduit.commentaire;
      //       this.dateFinPrevue = response.data.consigneProduit && response.data.consigneProduit.date_fin ? this.formatDate(response.data.consigneProduit.date_fin) : '';
      //       this.piecesJointes = response.data.consigneProduit.consigne_attachments && response.data.consigneProduit.consigne_attachments.length > 0 ? response.data.consigneProduit.consigne_attachments : '';
      //     });
      // },
      isConsigneExpired(dateFin) {
        let today = new Date().getTime()
        let dateTo = new Date(dateFin)
        if (dateFin !== null) {
          if (dateTo.getTime() > today) {
            return false
          }
        }
        return true;
      },
      getConsigneGarantie(garantie, famille_produit_id) {
        this.$axios
          .get('/espaceGestion/consignes-garanties/' + garantie + '/' + famille_produit_id)
          .then(response => {
            let consignes = response.data.consigneProduit
            for (let i in consignes) {
              if (!this.isConsigneExpired(consignes[i].date_fin)) {
                this.blocConsignes.push(consignes[i]);
                this.nbConsigne++;
              }
            }
            // this.blocConsignes = response.data.consigneProduit
            this.consigneTraitementFamille = response.data.consigneProduit && response.data.consigneProduit.commentaire;
            this.dateFinPrevue = response.data.consigneProduit && response.data.consigneProduit.date_fin ? this.formatDate(response.data.consigneProduit.date_fin) : '';
            this.piecesJointes = response.data.consigneProduit.consigne_attachments && response.data.consigneProduit.consigne_attachments.length > 0 ? response.data.consigneProduit.consigne_attachments : '';
          });
      },
      getConsignes() {
        let self = this;
        let segmentId = !isEmpty(this.$parent.$parent.$parent.sirenPreference) && this.$parent.$parent.$parent.sirenPreference.segment_gestion_id ? this.$parent.$parent.$parent.sirenPreference.segment_gestion_id : ''
        let dataPost = {
          segmentId: segmentId,
          siren: this.dossier.siren,
          nir: this.dossier.nir,
        }
        this.$axios
          .post('/espaceGestion/consignes-all', dataPost)
          .then(response => {
            let consignesSegment = response.data.consignes && response.data.consignes.segment;
            for (let i in consignesSegment) {
              if (!this.isConsigneExpired(consignesSegment[i].date_fin)) {
                this.consignesSegment.push(consignesSegment[i]);
                this.nbConsigne++;
              }
            }
            // this.consignesSegment = response.data.consignes && response.data.consignes.segment;
            let consignesSiren = response.data.consignes && response.data.consignes.siren;
            for (let i in consignesSiren) {
              if (!this.isConsigneExpired(consignesSiren[i].date_fin)) {
                this.consignesSiren.push(consignesSiren[i]);
                this.nbConsigne++;
              }
            }


            let consignesNir = response.data.consignes && response.data.consignes.nir;
            for (let i in consignesNir) {
              if (!this.isConsigneExpired(consignesNir[i].date_fin)) {
                this.consignesNir.push(consignesNir[i]);
                this.nbConsigne++;
              }
            }
            // this.consignesSiren = response.data.consignes && response.data.consignes.siren;

            let consignesBlocage = response.data.consignes && response.data.consignes.blocage;
            for (let i in consignesBlocage) {
              if (!this.isConsigneExpired(consignesBlocage[i].date_fin)) {
                this.consignesBlocage.push(consignesBlocage[i]);
                this.nbConsigne++;
              }
            }

          })
          .catch(error => {
            self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue pendant la récupération des consignes. Essayez de faire F5, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
          });
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique );
        return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId,10) === treatment.id
      },
      // calculClassBlocGestion(bloc) {
      //   let classOption = '';

      //   switch (bloc) {
      //     case 'produit' :
      //       classOption = isEmpty(this.consigneTraitementFamille) && (this.consignesSegment.length > 0 || this.consignesSiren.length > 0 || !isEmpty(this.dossier.code_blocage)) ? 'd-none' : 'col-md-12';
      //       break;
      //     case 'codeBlocage' :
      //       classOption = isEmpty(this.dossier.code_blocage) ? 'd-none' : 'col-md-12';
      //       break;
      //     case 'siren' :
      //       if (this.consignesSiren.length === 0) {
      //         classOption = 'd-none';
      //       } else {
      //         classOption = 'col-md-12';
      //       }
      //       break;
      //     case 'segment' :
      //       if (this.consignesSegment.length === 0) {
      //         classOption = 'd-none';
      //       } else {
      //         classOption = 'col-md-12';
      //       }
      //       break;
      //   }
      //   return classOption;
      // },
      formatDate(textDate) {
        let date = textDate !== null? new Date(textDate).toLocaleDateString('fr-FR') : '-'
        return date
      },
      formatBytes(bytes, precision = 2) {
        let units = ['o', 'Ko', 'Mo', 'Go', 'To']

        let varBytes = Math.max(bytes, 0);
        let pow = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(1024))
        pow = Math.min(pow, units.length - 1)

        varBytes /= Math.pow(1024, pow)

        return Math.round(varBytes, precision) + ' ' + units[pow]
      },
      canDownloadGuardedFile(extension) {
        let valid = true;
        if(_.includes(guardedFile, extension)) {
          valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
        }
        return valid;
      },
      download(id, filename) {
        let fileNameArr = filename.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        let link = document.getElementById('pj_'+id);
        link.style.color = 'violet';
        // console.log('link',link)
        if(this.canDownloadGuardedFile(ext)) {
          this.$axios
            .get("/espaceGestion/consignes-produits/piece-jointe/download/"+id, {responseType: 'blob'})
            .then(response => {
              downloadFile(response, name, ext);
            })
            .catch(() => {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 4000
              });
            })
        } else {
          this.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
            showConfirmButton: false,
            timer: 3500
          });
        }
      },
      accessBibliotheque() {
        // window.open(`/espace-bibliotheque/accueil?familleProduitId=${this.dossier.famille_produit_id}`, '_blank')
        console.log(this.dossier)
        if (!isEmpty(this.dossier.famille_produit) && this.dossier.famille_produit.libelle != 'Non déterminé') {
          window.open(`/espace-bibliotheque/accueil/familleProduit/${this.dossier.famille_produit.gamme_id}?secteur=${this.dossier.famille_produit.secteur}`, '_blank')
        } else {
          window.open('/espace-bibliotheque/accueil', '_blank')
        }
      }
    }
  }
</script>
